// ** React Imports
import ReactDOM from "react-dom";
import React, { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";

// ** Redux Imports
import { store } from "./redux/store";
import { Provider } from "react-redux";

// ** ThemeColors Context

import { ThemeContext } from "./utility/context/ThemeColors";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";
import { unProtectedRoutes } from "./UnprotectedRoutes";

import { handleLogout } from "./redux/auth/index";
import { createBrowserHistory } from "history";
import { ToastContainer } from "react-toastify";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import "./@core/scss/react/libs/flatpickr/flatpickr.scss";

Bugsnag.start({
  apiKey: "977c4b3681027ff3d1bcf6bbc3e65d17",
  plugins: [new BugsnagPluginReact()],
  // enabledReleaseStages: ["production", "staging"],
});
import { IntlProviderWrapper } from "./utility/context/Internationalization";

const BugSnagBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

//handle auth
const history = createBrowserHistory();
const token = localStorage.getItem("userToken");
const routes = history.location.pathname.split("/");
const unAuthorizedRoutes = unProtectedRoutes.filter((upRoutes) =>
  routes.includes(upRoutes)
)?.length;

if (token) {
  if (window.location.pathname == "/login") history.push("/");
} else {
  if (!unAuthorizedRoutes) {
    history.push("/login");
  }
}
ReactDOM.render(
  <BugSnagBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <Suspense fallback={<Spinner />}>
          <ThemeContext>
            <IntlProviderWrapper>
              <LazyApp />
              <Toaster
                position={themeConfig.layout.toastPosition}
                toastOptions={{ className: "react-hot-toast" }}
              />
              <ToastContainer />
            </IntlProviderWrapper>
          </ThemeContext>
        </Suspense>
      </Provider>
    </BrowserRouter>
  </BugSnagBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
